import React, { useState } from 'react';

import { FilterContainer, Title, Hr, CheckboxContainer } from './styles';
import { Checkbox } from 'components/Checkbox/Checkbox';

export default function Filter({ filterOptions, filterValues }) {
  const [filter, setFilter] = useState(filterOptions);

  const setValue = (change) => {
    let filterCopy = { ...filter, ...change };
    setFilter(filterCopy);
    return filterValues(filterCopy);
  };

  return (
    <FilterContainer id="customTestsFilter">
      <Title>Contests</Title>
      <Hr />
      <CheckboxContainer>
        <Checkbox
          checked={filter.hasContests}
          onChange={() => setValue({ hasContests: !filter.hasContests })}
          label="Available"
        />
        <Checkbox
          checked={filter.noContests}
          onChange={() => setValue({ noContests: !filter.noContests })}
          label="Not Available"
        />
        <Hr />
      </CheckboxContainer>
      <Title>Category</Title>
      <Hr />
      <CheckboxContainer>
        <Checkbox
          checked={filter.isChallenge}
          onChange={() => setValue({ isChallenge: !filter.isChallenge })}
          label="Challenge"
        />
        <Checkbox
          checked={filter.isTournament}
          onChange={() => setValue({ isTournament: !filter.isTournament })}
          label="Tournament"
        />
      </CheckboxContainer>
    </FilterContainer>
  );
}
